import React from "react";
import {Button, Input, Modal, Table} from "antd";
import {pagination} from "../../../../controller/Utils";
import {GeneratorGet, GeneratorList} from "../../../../models/generator";
import {EditGeneratorData} from "../../../tracks/data_management/generator_data/popups/EditGeneratorData";


const Search = Input.Search;

export class GeneratorClientData extends React.Component {
  state = {
    visible: false,
    data: [],
    value: [],
    selectedGenerator: {},
    fetching: false,
    generatorListVisible: false,
    confirmLoading: false,
    loading: false,
    search: '',
    pagination: pagination,
  };

  handleTableChange = (pagination, filters, sorter) => {
    const pager = {...this.state.pagination};
    pager.current = pagination.current;
    this.setState({
      pagination: pager,
    });
    let symbol = '';
    if (sorter.order === 'descend')
      symbol = '-';
    const requestData = {
      results: pagination.pageSize,
      page: pagination.current,
      ordering: `${symbol}${sorter.columnKey}`,
      search: this.state.search,
      ...filters,
    };
    GeneratorList(requestData)
      .then(body => {
        const data = body.data.results;
        this.setState({data, fetching: false, loading: false});
      });
  };
  fetchGenerator = (value = '') => {
    this.setState({loading: true, fetching: true, search: value});
    const requestData = {'search': value};
    GeneratorList(requestData)
      .then(body => {
        const data = body.data.results;
        const pagination = {...this.state.pagination};
        pagination.total = body.data.count;
        this.setState({data, fetching: false, loading: false, pagination});
      });
  };

  setSelectedValue = (value) => {
    this.setState({confirmLoading: true});
    if (value.id !== undefined) {
      this.setState({generatorID: value.id});
      this.props.selectedGenerator(value);
    }
    this.props.onClose();
  };

  onRowUpdateClick = (row_id) => {
    this.setEditGenerator(true);
    this.setState({row_id})
  };
  columns = [{
    title: 'Account Number',
    dataIndex: 'account_number',
    sorter: true
  }, {
    title: 'Company Name',
    dataIndex: 'company_name',
    sorter: true
  }, {
    title: 'Phone',
    dataIndex: 'phone',
  }, {
    title: 'Address',
    dataIndex: 'address',
    render: (address) => <span className="select-data-add">{address}</span>,
  }, {
    title: 'City',
    dataIndex: 'city',
    sorter: true
  }, {
    title: 'Zip Code',
    dataIndex: 'zip_code',
  },
    {
      title: 'Action',
      render: (row) => <div className="select-pop-action">
        <Button className="ant-btn ant-btn-primary" onClick={() => this.setSelectedValue(row)}><i className="fa fa-check"/>
        </Button>
        <Button onClick={() => this.onRowUpdateClick(row.id)} className="ant-btn ant-btn-primary edit-gen"><i
          className="fa fa-pencil"/></Button>
      </div>
    }];
  setGeneratorToSelectedData = (id) => {
    GeneratorGet(id)
      .then(response => {
        this.setState({selectedGenerator: response.data})
      })
  };

  setEditGenerator(modelEditGenerator) {
    const {row_id} = this.state;
    this.setState({modelEditGenerator});
    if (!modelEditGenerator)
      this.setState({row_id: modelEditGenerator});
    if (row_id)
      this.setGeneratorToSelectedData(row_id)
  }

  componentDidMount() {
    if (this.props.onRef)
      this.props.onRef(this)
  }

  componentWillUnmount() {
    if (this.props.onRef)
      this.props.onRef(null)
  }

  render() {
    const {data, loading, pagination} = this.state;
    return (
      <div>
        <Modal className="gen-list-mdl" destroyOnClose={true} title="Generator List" onCancel={this.props.onClose}
               okButtonProps={{disabled: true}} visible={this.props.visible} width='90%'>
          <Search className="gen-tbl-search" placeholder="Search Here For Generator" onSearch={this.fetchGenerator}
                  style={{width: 500}}/>
          <Table onRow={(row) => {return {onClick: () => {this.setSelectedValue(row)}}}}
                 className="select-data-tbl" pagination={pagination} onChange={this.handleTableChange} loading={loading}
                 columns={this.columns} dataSource={data} rowKey={row => row.id}/>
        </Modal>
        <EditGeneratorData fetch={() => this.fetchGenerator()} row_id={this.state.row_id}
                           visible={this.state.modelEditGenerator}
                           setModelVisible={() => this.setEditGenerator(false)}/>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/pages/crm/client_profile/generator-client/GeneratorClientData.jsx